<template>
  <v-container class="pa-0">
    <div class="main-preload">
      <div class="main-preload__content">
        <terms-of-use-page v-on:submit="onSubmit" />
      </div>

      <div class="terms-of-use-modal__sidebar">
        <img src="@/assets/img/accept-docs.svg" alt="">
      </div>
    </div>
  </v-container>
</template>

<script>
  import TermsOfUsePage from '@/components/Modals/TermsOfUse/TermsOfUsePage.vue';

  export default {
    name: 'MainPreload',
    components: {
      TermsOfUsePage
    },
    methods: {
      onSubmit() {
        this.$emit('submit');
      }
    }
  };
</script>

<style>
  .main-preload {
    display: flex;
    flex: 1 1 auto;
    height: 100%;
    align-items: center;
    position: relative;
    justify-content: center;
  }

  .main-preload__content {
    width: 60%;
    margin-right: 10%;
    max-width: 600px;
  }
  
  .terms-of-use-modal__sidebar {
    position: relative;
    width: 40%;
    max-width: 500px;
    background: var(--color-white-smoke);
    border-radius: 50px;
    height: 70%;
  }

  .terms-of-use-modal__sidebar img {
    position: absolute;
    top: 50%;
    left: -10%;
    transform: translateY(-50%);
  }

</style>

